export default __webpack_public_path__ + "static/media/compost.3bc742a8.png";